<ng-container *ngLet="{
  isInternalUser: isInternalUser$ | async,
  isWmBranch: isWmBranch$ | async,
  currencyCode: currencyCode$ | async
} as vm">
  <div class="row order-confirmation-order-item-row py-2" id="orderItem_tr_{{idSuffix}}_{{index}}">
    <div [ngClass]="createColumnClass('partNumber', vm.isInternalUser)">
      @if (isHotFlagValid) {
        <span style="padding-right: 4px; font-weight: bold;">*</span>
      }
      {{orderItem.partNumber}}
    </div>
    <div [ngClass]="createColumnClass('item', vm.isInternalUser)">
      {{orderItem.description}}
      <br>
        @if (coreOptionText) {
          <span>
            {{coreOptionText}}
          </span>
        }
      </div>
      @if (orderItem?.isHotFlag) {
        <div class="text-end" [ngClass]="createColumnClass('hotFlag', vm.isInternalUser)">{{getHotFlagValueByCode(orderItem?.hotFlagCode)}}</div>
      }
      <div class="text-end" [ngClass]="createColumnClass('qty', vm.isInternalUser)">{{orderItem.quantity}}</div>
      @if (showCouponColumn) {
        <div class="text-end" id="orderItem_td_{{idSuffix}}WithCoupons_{{index}}" [ngClass]="createColumnClass('totalCoupon', vm.isInternalUser)">
          @if (couponValue) {
            <span id="orderItem_div_{{idSuffix}}CouponValue_{{index}}" class="text-danger">
              {{couponValue || 0 | currency: vm.currencyCode :'symbol':'1.2-2'}}
            </span>
          }
        </div>
      }
      <div class="text-end" [ngClass]="createColumnClass('total', vm.isInternalUser)">
        @if (orderItem.isSpecialPricing) {
          <div id="orderItem_div_{{idSuffix}}IsSpecialPricing_{{index}}" class="text-danger">Special Sale Price</div>
        }
        <div id="orderItem_div_{{idSuffix}}Price_{{index}}" [ngClass]="orderItem.isSpecialPricing ? 'text-danger' : ''">
          {{orderItemValue | currency: vm.currencyCode :'symbol':'1.2-2'}}
          @if (orderItem.isPriceVerified) {
            <a id="orderItem_a_{{idSuffix}}Verify_{{index}}" class="btn price-verify-icon" style="cursor:default; color:#fff;">v</a>
          }
        </div>
      </div>
      @if (vm.isInternalUser) {
        <div class="text-start" id="orderItem_td_{{idSuffix}}JobNumber_{{index}}" [ngClass]="createColumnClass('jobNumber', vm.isInternalUser)">
          {{orderItem.jobNumber}}
          @if (vm.isWmBranch) {
            <span>{{orderItem.deliveryOption}}</span>
          }
          @if (isHotFlagValid) {
            <span style="padding-left: 10px; font-weight: bold;">*</span>
          }
        </div>
      }
    </div>
  </ng-container>
